export const LOGO_HREF = "https://www.chubb.com/us-en/business-insurance/products/cyber-insurance.html";